module.exports = __webpack_public_path__ + "static/MiriamYang-4cb24452ee13d5bd32e8da3969583672.png";